<template lang="html">
  <div class="mt-5">
    <vs-tabs
      alignment="fixed"
      :color="colorx"
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        :label="!isSmallerScreen ? 'My Profile' : ''"
        icon-pack="feather"
        icon="icon-user"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Branch"
                  class="w-full"
                  :value="actor.branch ? actor.branch.name : '-'"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Parent"
                  class="w-full"
                  :value="actor.parent ? actor.parent.username : '-'"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Privilege"
                  class="w-full"
                  :value="defaultPrivilegeList[actor.privilege]"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Status"
                  class="w-full"
                  :value="statusList[actor.status]"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Username"
                  class="w-full"
                  :value="actor.username"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Fullname"
                  class="w-full"
                  :value="actor.fullname"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label mb-2">Email</label>
                <table class="w-full">
                  <tr>
                    <td>
                      <vs-input disabled class="w-full" :value="actor.email" />
                    </td>
                    <td>
                      <vs-icon
                        :title="
                          actor.is_verified_email
                            ? 'The email has been verified'
                            : 'The email has not been verified'
                        "
                        :icon="actor.is_verified_email ? 'check' : 'close'"
                        size="25px"
                        color="white"
                        :bg="actor.is_verified_email ? 'success' : 'danger'"
                        round
                        class="ml-5"
                      ></vs-icon>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label mb-2">Phone</label>
                <table class="w-full">
                  <tr>
                    <td>
                      <vs-input disabled class="w-full" :value="actor.phone" />
                    </td>
                    <td>
                      <vs-icon
                        :title="
                          actor.is_verified_phone
                            ? 'The phone has been verified'
                            : 'The phone has not been verified'
                        "
                        :icon="actor.is_verified_phone ? 'check' : 'close'"
                        size="25px"
                        color="white"
                        :bg="actor.is_verified_phone ? 'success' : 'danger'"
                        round
                        class="ml-5"
                      ></vs-icon>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  disabled
                  label="Type"
                  class="w-full"
                  :value="typeList[actor.type]"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-8">
                <vs-input
                  disabled
                  label="Company Name"
                  class="w-full"
                  :value="actor.company_name"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-textarea
                  disabled
                  label="Address"
                  class="w-full"
                  rows="3"
                  :value="actor.address"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </vs-tab>

      <vs-tab
        :label="!isSmallerScreen ? 'Edit Profile' : ''"
        icon-pack="feather"
        icon="icon-edit"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div class="tab-text">
              <div class="vx-row mb-3">
                <div class="vx-col sm:w-1/2 w-full required">
                  <vs-input
                    disabled
                    label="Username"
                    class="w-full"
                    v-model="input.username"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full required">
                  <vs-input
                    label="Fullname"
                    class="w-full"
                    v-model="input.full_name"
                  />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col sm:w-1/2 w-full required">
                  <table width="100%" v-if="actor.privilege <= 4">
                    <tr>
                      <td style="width: 65%">
                        <vs-input
                          label="Email"
                          class="w-full"
                          v-model="input.email"
                        />
                      </td>
                      <td>
                        <vs-icon
                          :title="
                            actor.is_verified_email
                              ? 'The email has been verified'
                              : 'The email has not been verified'
                          "
                          :icon="actor.is_verified_email ? 'check' : 'close'"
                          size="25px"
                          color="white"
                          :bg="actor.is_verified_email ? 'success' : 'danger'"
                          round
                          class="ml-4 mt-8"
                        ></vs-icon>
                      </td>
                      <td style="float: right">
                        <vs-button
                          id="submitBtnVerifEmail"
                          class="ml-4 mt-8 vs-con-loading__container"
                          :disabled="actor.is_verified_email"
                          @click="verifEmail"
                          >Verification Email</vs-button
                        >
                      </td>
                    </tr>
                  </table>

                  <vs-input
                    v-else
                    label="Email"
                    class="w-full"
                    v-model="input.email"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full required">
                  <vs-input
                    label="Phone"
                    class="w-full"
                    v-model="input.phone"
                  />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col sm:w-1/2 w-full mb-8">
                  <vs-input
                    label="Company Name"
                    class="w-full"
                    v-model="input.company_name"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    label="Address"
                    class="w-full"
                    rows="3"
                    v-model="input.address"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full ml-auto">
                  <vs-button
                    v-if="this.actor.username != 'demo'"
                    id="submitBtnEdit"
                    class="mr-3 mb-2 vs-con-loading__container"
                    @click="submitEditUser"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </vs-tab>

      <vs-tab
        :label="!isSmallerScreen ? 'Change Password' : ''"
        icon-pack="feather"
        icon="icon-lock"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div class="tab-text">
              <div class="tab-text">
                <div class="vx-row mb-3">
                  <div class="vx-col w-full required pb-2">
                    <vs-input
                      type="password"
                      label="Old Password"
                      class="w-full"
                      v-model="input.old_password"
                    />
                  </div>
                  <div class="vx-col w-full required pb-2">
                    <vs-input
                      type="password"
                      label="New Password"
                      class="w-full"
                      v-model="input.password"
                    />
                  </div>
                  <div class="vx-col w-full required">
                    <vs-input
                      type="password"
                      label="Confirm New Password"
                      class="w-full"
                      v-model="input.password1"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full ml-auto">
                    <vs-button
                      v-show="this.actor.username != 'demo'"
                      id="submitBtnChangePwd"
                      class="mr-3 mb-2 vs-con-loading__container"
                      @click="submitChangePwd"
                      >Submit</vs-button
                    >
                    <vs-button
                      color="warning"
                      type="border"
                      class="mb-2"
                      @click="reset"
                      >Reset</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-else>
              <vs-alert
                class="mt-4"
                color="dark"
                icon-pack="feather"
                icon="icon-info"
              >
                <span>The feature is not available on Limited User!</span>
              </vs-alert>
            </div> -->
          </vx-card>
        </div>
      </vs-tab>

      <vs-tab
        :label="!isSmallerScreen ? 'Email Subscription' : ''"
        icon-pack="feather"
        icon="icon-mail"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div v-if="actor.privilege === 4" class="tab-text">
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <vs-input
                    type="email"
                    label="Email"
                    class="w-full"
                    v-model="subscription.email"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full ml-auto">
                  <vs-button
                    :disabled="loading"
                    id="submitBtnSubscription"
                    class="mr-3 mb-2 vs-con-loading__container"
                    @click="submitSubscription"
                    >Submit</vs-button
                  >
                  <vs-button
                    color="warning"
                    type="border"
                    class="mb-2"
                    @click="reset"
                    >Reset</vs-button
                  >
                </div>
              </div>
              <div>
                <table class="table mt-4">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Email</th>
                      <th>Verified</th>
                      <th>Subscribe</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="emailList.length > 0">
                    <tr v-for="(item, index) in emailList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        {{ item.email }}
                      </td>
                      <td>
                        <alert-triangle-icon
                          v-if="!item.is_verified"
                          size="14"
                          style="color: red"
                        ></alert-triangle-icon>
                        <check-circle-icon
                          v-else
                          size="14"
                          style="color: green"
                        ></check-circle-icon>
                      </td>
                      <td>
                        <vs-switch
                          :disabled="!item.is_verified"
                          color="success"
                          v-model="emailList[index].is_subscription"
                          @click="update_status(index)"
                          icon-pack="feather"
                          vs-icon-off="icon-x"
                          vs-icon-on="icon-check"
                        />
                      </td>
                      <td>
                        <div class="flex">
                          <vx-tooltip text="Delete" position="top">
                            <vs-button
                              type="border"
                              size="small"
                              icon-pack="feather"
                              icon="icon-trash"
                              color="danger"
                              @click="del(item.id)"
                            ></vs-button>
                          </vx-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="7">No Data</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <vs-alert
                class="mt-4"
                color="dark"
                icon-pack="feather"
                icon="icon-info"
              >
                <span>The feature is only available for General User!</span>
              </vs-alert>
            </div>
          </vx-card>
        </div>
      </vs-tab>

      <vs-tab
        :label="!isSmallerScreen ? 'Permission' : ''"
        icon-pack="feather"
        icon="icon-info"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div class="tab-text">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex items-end px-3">
                    <!-- <feather-icon svgClasses="w-6 h-6" icon="DashboardIcon" class="mr-2" /> -->
                    <span class="font-medium text-lg leading-none"
                      >My Menu</span
                    >
                  </div>
                  <vs-divider />
                </div>
              </div>
              <div v-show="actor.privilege === 1">
                <vs-alert color="success" icon-pack="feather" icon="icon-info">
                  <span
                    >You are the
                    <b>{{ defaultPrivilegeList[actor.privilege] }}</b
                    >, you have full access in the system</span
                  >
                </vs-alert>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full ml-6">
                  <ul class="mt-3">
                    <li
                      v-for="(i, index) in menuList"
                      :key="index"
                      class="mb-2"
                    >
                      <vs-checkbox
                        v-if="
                          actor.permission &&
                          JSON.parse(actor.permission).indexOf(i.id) !== -1
                        "
                        disabled
                        value="true"
                        :style="i.parent ? 'margin-left: 30px' : ''"
                        >{{ i.name }}</vs-checkbox
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="actor.permission == null && actor.privilege !== 1">
                <vs-alert color="warning" icon-pack="feather" icon="icon-info">
                  <span><b>No Access.</b> Please call the Administrator</span>
                </vs-alert>
              </div>
            </div>
          </vx-card>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { AlertTriangleIcon, CheckCircleIcon } from 'vue-feather-icons'

export default {
  components: {
    vSelect,
    AlertTriangleIcon,
    CheckCircleIcon
  },

  data() {
    return {
      loading: false,
      colorx: '#479DD7',

      actor: {},
      action: '',
      tempId: 0,
      actors: '',

      defaultPrivilegeList: [
        '',
        'Super Administrator',
        'Administrator',
        'Admin Cabang',
        'General User',
        'Dispatcher',
        'Limited User'
      ],

      typeList: ['Basic', 'Premium'],

      statusList: ['Inactive', 'Active'],

      menuList: [],
      menuDividerIndex: 0,

      input: {
        username: '',
        full_name: '',
        company_name: '',
        phone: '',
        email: '',
        address: '',
        old_password: '',
        password: '',
        password1: ''
      },

      subscription: {
        email: ''
      },

      emailList: [],

      portal_user_id: '',

      notify: 'Server Error'
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        var data = res.data.message.data
        this.portal_user_id = data.portal_user_id

        if (data.privilege === 4) this.getEmailSubscription()

        this.getProfile()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.getMenuList()
  },

  mounted() {},

  methods: {
    update_status(index) {
      this.$http
        .post(
          `${this.$api.endpoint}/email_subscription/update_status/${this.emailList[index].id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    reset() {
      this.input.old_password = ''
      this.input.password = ''
      this.input.password1 = ''

      Object.keys(this.subscription).map((item) => {
        this.subscription[item] = ''
      })
    },

    submitEditUser() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtnEdit',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.portal_host}/user/update/${this.actor.id}`,
          {
            username: this.input.username,
            fullname: this.input.full_name,
            email: this.input.email,
            phone: this.input.phone,
            company_name: this.input.company_name,
            address: this.input.address,

            branch_id: this.actor.branch.id,
            parent: this.actor.parent ? this.actor.parent.id : 0,
            privilege: this.actor.privilege,
            status: this.actor.status,

            sync: 'seen'
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtnEdit > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.$store.dispatch('updateUserInfo', {
            full_name: this.input.full_name,
            privilege: this.actor.privilege
          })

          this.getProfile()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtnEdit > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    verifEmail() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtnVerifEmail',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.portal_host}/user/verification/send_email_new`,
          {
            email: this.input.email
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtnVerifEmail > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtnVerifEmail > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    submitChangePwd() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtnChangePwd',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.portal_host}/user/update_password`,
          {
            old_password: this.input.old_password,
            password: this.input.password,
            password_confirmation: this.input.password1
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtnChangePwd > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })

          this.reset()
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtnChangePwd > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    getEmailSubscription() {
      this.$http
        .get(`${this.$api.endpoint}/email_subscription`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.emailList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submitSubscription() {
      this.loading = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtnSubscription',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.endpoint}/email_subscription/add`,
          {
            email: this.subscription.email
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.loading = false
          this.$vs.loading.close('#submitBtnSubscription > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')
          this.reset()
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
          this.getEmailSubscription()
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close('#submitBtnSubscription > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Email`,
        text: 'Are you sure want to delete this email ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/email_subscription/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.getEmailSubscription()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getMenuList() {
      this.$http
        .get(`${this.$api.endpoint}/menu/`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.menuList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getProfile() {
      this.$http
        .get(`${this.$api.portal_host}/user/detail/${this.portal_user_id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            sync: 'seen'
          }
        })
        .then((res) => {
          const data = res.data.message.data

          this.actor = res.data.message.data

          this.input.username = data.username
          this.input.full_name = data.fullname
          this.input.email = data.email
          this.input.phone = data.phone
          this.input.company_name = data.company_name
          this.input.address = data.address
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
